import React, { useEffect, useRef, useState } from 'react';
import cls from '@utils/css-select';
import { I18nMessage } from '@fe/i18n';

import styles from './styles.scss';
import Section from 'components/section';
import { useSelector } from 'react-redux';
import { GRADE_COUNTRY_CONIFG } from './const';
import { ConnectState } from 'states/connect';
const cx = cls(styles);

const TabList = [
	{
		id: 'tab_01',
		name: 'Elementary',
	},
	{
		id: 'tab_02',
		name: 'Middle',
	},
	{
		id: 'tab_03',
		name: 'High',
	},
];

const Message = I18nMessage('landing');
/**
 *年级区域
 * @export
 * @returns
 */
export default function GradeBlock() {
	const [curId, setCurId] = useState('tab_01');
	const local = useSelector((state: ConnectState) => state.app.local);
	const grades = GRADE_COUNTRY_CONIFG[local] || GRADE_COUNTRY_CONIFG['en-US'];
	const ref = useRef<HTMLDivElement>(null);
	/**
	 * tab切换
	 */
	function handleTabClick(e: React.MouseEvent<HTMLLIElement>) {
		const { id = '' } = e.currentTarget.dataset;
		setCurId(id);
		const scrollRef = ref.current;
		const ele = document.querySelector(`#${id}`) as HTMLDivElement;
		const left = ele.offsetLeft;
		// eslint-disable-next-line no-unused-expressions
		scrollRef?.scrollTo(id === 'tab_01' ? 0 : left - 50, 0);
	}
	useEffect(() => {
		const scrollRef = ref.current;
		if (!scrollRef) return;
		const tabContent1 = document.querySelector(`#tab_01`) as HTMLDivElement;
		const tabContent2 = document.querySelector(`#tab_02`) as HTMLDivElement;
		const tabContent3 = document.querySelector(`#tab_03`) as HTMLDivElement;
		const offsets = [tabContent1.offsetLeft, tabContent2.offsetLeft, tabContent3.offsetLeft];
		function moveListener(e: Event) {
			const ele = e.currentTarget as HTMLDivElement;
			// ele.scrollLeft;
			if (ele.scrollLeft >= 0 && ele.scrollLeft < offsets[1] - 50) {
				setCurId('tab_01');
			} else if (ele.scrollLeft > offsets[1] - 100 && ele.scrollLeft < offsets[2] - 200) {
				setCurId('tab_02');
			} else {
				setCurId('tab_03');
			}
		}
		scrollRef.addEventListener('scroll', moveListener);
		return () => {
			scrollRef.removeEventListener('scroll', moveListener);
		};
	}, []);
	return (
		<div className={cx('grade-list')}>
			<Section>
				<h3 className={cx('block-title', 'black')}>
					<Message id="grade_tit" />
				</h3>
				<ul className={cx('tabs')}>
					{TabList.map((v) => {
						return (
							<li
								className={cx('tab', {
									active: v.id === curId,
								})}
								onClick={handleTabClick}
								key={v.name}
								data-id={v.id}>
								{v.name}
								<span>School</span>
							</li>
						);
					})}
				</ul>
				<div className={cx('grade-scroll', 'scroll-view')} ref={ref}>
					{grades.map((v, idx) => {
						return (
							<div key={idx} className={cx('grade-item')} id={`tab_0${idx + 1}`}>
								<header style={{ backgroundImage: `url(${v.bg})` }}>{v.title}</header>
								<div className={cx('intro')} dangerouslySetInnerHTML={{ __html: v.intro }} />
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
